import { css, html, LitElement } from 'lit';
import { getAssetPath } from '@stencil/core';
import { Image } from '../../Image/Image';
import '../../Inputbox/Input';
import { Button } from '../../Buttons/Buttons';
import '../../../Components/TestFooter/MentionUserList'; // Import the new mention user list component
import '../CameraPreview';
export class AttachmentPreview extends LitElement {
  static properties = {
    content: { type: Array },
    contentType: { type: Array },
    selectedIndex: { type: Number },
    caption: { type: String },
    onClose: { type: Function },
    onSend: { type: Function },
    inputValue: { type: String },
    inputBorderColor: { type: String },
    inputBorderWidth: { type: String },
    inputBorderStyle: { type: String },
    inputPlaceholder: { type: String },
    inputBgColor: { type: String },
    inputFontSize: { type: String },
    inputFontColor: { type: String },
    inputBorderRadius: { type: String },
    inputContainerBorderColor: { type: String },
    inputContainerBorderWidth: { type: String },
    inputContainerBorderRadius: { type: String },
    inputPlaceholderColor: { type: String },
    inputContainerPadding: { type: String },
    showCloseIcon: { type: String },
    sendButtonIconHeight: { type: String },
    sendButtonIconWidth: { type: String },
    conversationDetails: { type: Object },

    // New mention-related properties
    showMentionList: { type: Boolean },
    mentionSearchQuery: { type: String },
    cursorPosition: { type: Number },
    userMetaData: { type: Object },
    showCamera: { type: Boolean }
  };

  constructor() {
    super();
    this.selectedIndex = 0;
    this.caption = '';
    this.tools = [
      { icon: '⟲', label: 'Crop' },
      { icon: '⚭', label: 'Filter' },
      { icon: '✎', label: 'Edit' },
      { icon: 'T', label: 'Text' },
      { icon: '▦', label: 'Effects' }
    ];
    this.imagePlaceholder = getAssetPath('./assets/images/imagePlaceholder.svg');
    this.videoPlaceholder = getAssetPath('./assets/images/videoThumbnail.svg');
    this.pdfPlaceholder =getAssetPath ('./assets/images/pdf.png');
    this.docPlaceholder = getAssetPath('./assets/images/doc.png');
    this.rtfPlaceholder = getAssetPath('./assets/images/rtf.png');
    this.odtPlaceholder = getAssetPath('./assets/images/odt-file.png');
    this.txtPlaceholder = getAssetPath('./assets/images/txt.png');
    this.showCamera = false;
    this.sendButtonIconHeight = '50px';
    this.sendButtonIconWidth = '50px';
    this.sendButtonIconRadius = '50%';
    this.inputBgColor = 'var(--bg-message-input-color)';
  }

  static styles = css`
    :host {
      display: block;
      background-color: var(--bg-primary-color);
      color: var(--text-primary-color);
      height: calc(100dvh - 224px);
      width: 100%;
      overflow: auto;
    }

    .preview-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 8px;
      box-sizing: border-box;
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .tools-group {
      display: flex;
      gap: 16px;
    }

    .tool-btn {
      background: none;
      border: none;
      color: var(--text-outgoing-message);
      font-size: 25px;
      cursor: pointer;
      font-weight: bold;
      opacity: 0.8;
      transition: opacity 0.2s;
      padding: 4px;
    }

    .tool-btn:hover {
      opacity: 1;
    }

    .preview-area {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: 8px 0;
      height: calc(100vh - 220px);
      position: relative;
      overflow: hidden;
      border-radius: 8px;
    }

    .preview-image {
      max-width: 100%;
      height: calc(100vh - 220px)!important;
      object-fit: contain;
      overflow:auto;
    }

    .caption-container {
    margin-left:80px;
    margin-right:80px;
      background-color: var(--bg-primary-color);
      border-radius: 8px;
      padding: 8px;
      position: relative;
    }

    .caption-input {
      flex: 1;
      background: none;
      border: none;
      color: var(--text-outgoing-message);
      font-size: 14px;
      padding: 4px 8px;
      outline: none;
    }

    .caption-input::placeholder {
      color: #8e8e8e;
    }

    .caption-tools {
      display: flex;
      gap: 8px;
    }

    .thumbnail-strip {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px;
      background-color: var(--bg-primary-color);
      height: 56px;
      border-top: 1px solid #000;
    }

    .thumbnails {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
      flex: 1;
      overflow-x: auto;
      padding: 2px;
    }

    .thumbnail {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      opacity: 0.7;
      transition: opacity 0.2s;
    }

    .thumbnail.selected {
      opacity: 1;
      border: 2px solid var(--base-color);
    }

    .thumbnail img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .add-media-btn {
      min-width: 48px;
      height: 48px;
      background-color: #2a2d30;
      border: none;
      border-radius: 4px;
      color: #ffffff;
      font-size: 20px;
      cursor: pointer;
      display: none;
      align-items: center;
      justify-content: center;
    }

    .send-btn {
      width: 40px;
      height: 40px;
      background-color: #00b894;
      border: none;
      border-radius: 50%;
      color: #ffffff;
      font-size: 18px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;
    }

    .send-btn:hover {
      background-color: #00a383;
    }

    .document-preview {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
    }

    .document-icon {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .document-icon img {
      width: 100px;
      height: 100px;
      object-fit: contain;
    }

    .document-name {
      color: var(--text-primary-color);
      font-size: 16px;
      text-align: center;
      word-break: break-word;
      max-width: 80%;
    }
      @media (max-width: 768px) {
      .caption-container{
      margin:0;
      }
      }
  `;

  handleThumbnailClick(index) {
    this.selectedIndex = index;
    this.dispatchEvent(new CustomEvent('thumbnailSelect', {
      detail: { index }
    }));
  }
  handleInputChange(event) {
    this.inputValue = event.target.value;
    this.dispatchEvent(
      new CustomEvent('input-change', {
        detail: { value: this.inputValue },
        bubbles: true,
        composed: true,
      }),
    );
  }

  handleToolClick(action) {
    this.dispatchEvent(new CustomEvent('toolClick', {
      detail: { action }
    }));
  }

  handleAddMedia() {
    this.dispatchEvent(new CustomEvent('addMedia'));
  }

  handleSend() {
    this.dispatchEvent(new CustomEvent('send', {
      detail: {
        selectedIndex: this.selectedIndex,
        caption: this.caption,
        content: this.content[this.selectedIndex],
        contentType: this.contentType[this.selectedIndex]
      }
    }));
  }
  handleCameraCapture(captureData) {
    const { file, type, src } = captureData;
    this.showCamera = false;

    this.dispatchEvent(
      new CustomEvent('file-uploaded', {
        detail: {
          files: [file],
          fileTypes: [type],
          totalFiles: 1
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  renderToolbar() {
    return html`
      <div class="toolbar">
        <button class="tool-btn" @click="${this.onClose}">✕</button>
      </div>
    `;
  }

  getPlaceholder(type) {
    if (type === 'image') {
      return this.imagePlaceholder;
    } else if (type === 'video') {
      return this.videoPlaceholder;
    } else if (type?.includes('pdf')) {
      return this.pdfPlaceholder;
    } else if (type?.includes('rtf')) {
      return this.rtfPlaceholder;
    } else if (type?.includes('txt')) {
      return this.txtPlaceholder;
    } else if (type?.includes('odt')) {
      return this.odtPlaceholder;
    } else if (type?.includes('doc')) {
      return this.docPlaceholder;
    } else {
      return null;
    }
  }


  renderPreviewArea() {
    const currentContent = this.content[this.selectedIndex];
    if (currentContent?.type === 'image') {
      return html`
        <div class="preview-area">
          ${Image({
            src: currentContent?.src || this.imagePlaceholder,
        alt: `preview-${this.selectedIndex}`,
            className: 'preview-image',
            placeholderImage: this.imagePlaceholder
      })}
        </div>
      `;
    }

    if (currentContent?.type === 'video') {
      return html`
        <div class="preview-area">
          <video 
            src="${currentContent?.src}" 
            controls 
            class="preview-image">
          </video>
        </div>
      `;
    }

    return html`
      <div class="preview-area document-preview">
        <span class="document-icon">
          ${Image({
      src: this.getPlaceholder(currentContent?.file?.type),
      alt: `preview-${this.selectedIndex}`,
    })}
      </span>
      <span class="document-name" > ${currentContent?.file?.name}</span>
      </div>
    `;
  }

  toggleAttachmentMenu() {
    this.isAttachmentMenuVisible = !this.isAttachmentMenuVisible;
    if (this.inputValue) {
      this.dispatchEvent(
        new CustomEvent('input-change', {
          detail: { value: '' },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  handleInputChange(event) {
    const newValue = event.target.value;

    const inputElement = this.shadowRoot.querySelector('my-input');
    const textArea = inputElement?.shadowRoot.querySelector('textarea');
    if (textArea) {
      this.cursorPosition = textArea.selectionStart;
    }

    this.checkForMentionTrigger(newValue);

    this.inputValue = newValue;
    this.lastInputValue = newValue;

    this.dispatchMentionEvent(newValue);
  }

  dispatchMentionEvent(text) {
    const mentionedUsers = this.extractMentions(text, this.conversationDetails?.members || []);

    this.dispatchEvent(
      new CustomEvent('mention-user', {
        detail: {
          value: text,
          mentionUsersList: mentionedUsers
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  checkForMentionTrigger(value) {
    const textBeforeCursor = value.substring(0, this.cursorPosition);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');

    if (lastAtIndex !== -1) {
      const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
      const nextChar = value.charAt(lastAtIndex + 1);

      if (lastAtIndex === textBeforeCursor.length - 1 ||
        (!textAfterAt.includes(' ') && nextChar !== '@')) {
        this.showMentionList = true;
        this.mentionSearchQuery = textAfterAt;
        return;
      }
    }

    this.showMentionList = false;
  }

  handleUserSelect(user) {
    const textBeforeCursor = this.inputValue.substring(0, this.cursorPosition);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    const textBeforeAt = this.inputValue.substring(0, lastAtIndex);
    const textAfterCursor = this.inputValue.substring(this.cursorPosition);

    const newValue = `${textBeforeAt}@${user.userName} ${textAfterCursor}`;
    this.inputValue = newValue;

    const newCursorPosition = lastAtIndex + user.userName.length + 2; 
    this.cursorPosition = newCursorPosition;

    this.updateInputWithMention(newValue, newCursorPosition);

    this.showMentionList = false;

    this.dispatchEvent(
      new CustomEvent('input-change', {
        detail: { value: newValue },
        bubbles: true,
        composed: true,
      }),
    );

    this.dispatchMentionEvent(newValue);
  }

extractMentions(text, members) {
  let mentionedUsers = [];
  let order = 1;
  
  for (const member of members) {
    if (!member?.userName) continue;
        const mentionText = `@${member.userName}`;
    let startIndex = 0;
    
    while (true) {
      const index = text.indexOf(mentionText, startIndex);
      if (index === -1) break;
      
      const isAtStart = index === 0 || /\s/.test(text[index - 1]);
      const endIndex = index + mentionText.length;
      const isAtEnd = endIndex >= text.length || /[\s,.!?;:]/.test(text[endIndex]);
      
      if (isAtStart && isAtEnd) {
        mentionedUsers.push({
          wordCount: member.userName.length,
          userId: member.userId,
          userName: member.userName,
          order: order++,
          position: index
        });
      }
      
      startIndex = index + 1;
    }
  }
  
  mentionedUsers.sort((a, b) => a.position - b.position);
  
  return mentionedUsers.map(({ position, ...user }) => user);
}
  updateInputWithMention(value, cursorPos) {
    setTimeout(() => {
      const inputElement = this.shadowRoot.querySelector('my-input');
      const textArea = inputElement?.shadowRoot.querySelector('textarea');
      if (textArea) {
        textArea.value = value;
        textArea.focus();
        textArea.setSelectionRange(cursorPos, cursorPos);
      }
    }, 0);
  }
  renderSendOrMicButton() {
    const buttonStyle = `
      width: ${this.sendButtonIconWidth};
      height: ${this.sendButtonIconHeight};
      border-width: 0px;
      border-color: var(--base-color);
      border-radius: ${this.sendButtonIconRadius};
      background-color: var(--base-color);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
    `;
      return html`
        <button style="${buttonStyle}" @click=${() => this.onSend()}>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#fff" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          >
            <path d="M22 2L11 13"></path>
            <path d="M22 2L15 22L11 13L2 9L22 2Z"></path>
          </svg>
        </button>
      `;
  }

  render() {
    if (this.showCamera) {
      return html`
        <camera-preview
           .onCapture="${(data) => this.handleCameraCapture(data)}"
          .onClose="${this.onClose}"
        ></camera-preview>
      `;
    }
    const currentContent = this.content?.[this.selectedIndex];
    const documentIcon = currentContent?.file ? this.getPlaceholder(currentContent.file.type) : null;
    const fileName = currentContent?.file?.name || '';

    const renderDocumentName = () => {
      if (!fileName) return null;
      return html`<div class="document-name">${fileName}</div>`;
    };

    return html`
      <div class="preview-container">
        ${this.renderToolbar()}
        <div class="preview-area document-preview">
          ${documentIcon ? html`
            <div class="document-icon">
              <svg width="100px" height="100px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="var(--base-color)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>doc-document</title> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="icon" fill="var(--base-color)" transform="translate(71.778133, 42.666667)"> <path d="M28.864,383.082667 L34.368,383.082667 C47.5093333,383.082667 57.2373333,380.928 63.5733333,376.661333 C69.12,372.970667 73.1306667,367.296 75.584,359.573333 C77.3973333,353.856 78.3146667,347.776 78.3146667,341.312 C78.3146667,334.378667 77.2693333,327.957333 75.1573333,322.048 C73.024,316.138667 70.144,311.530667 66.4746667,308.202667 C62.976,305.088 58.9866667,302.954667 54.528,301.845333 C50.0693333,300.736 43.3493333,300.16 34.368,300.16 L28.864,300.16 L28.864,383.082667 Z M-1.42108547e-14,405.696 L-1.42108547e-14,277.568 L35.456,277.568 C50.5386667,277.568 62.5706667,279.018667 71.616,281.92 C83.4346667,285.717333 92.4586667,292.757333 98.7306667,303.018667 C105.002667,313.301333 108.16,326.186667 108.16,341.674667 C108.16,357.589333 105.002667,370.581333 98.7306667,380.650667 C90.9013333,393.344 78.8053333,401.088 62.4,403.797333 C54.8693333,405.056 45.2266667,405.696 33.472,405.696 L-1.42108547e-14,405.696 Z M186.389333,297.915733 C175.957333,297.915733 167.914667,302.2464 162.24,310.929067 C157.12,318.779733 154.56,328.827733 154.56,341.115733 C154.56,355.345067 157.589333,366.395733 163.690667,374.225067 C169.408,381.649067 177.024,385.339733 186.474667,385.339733 C196.842667,385.339733 204.928,380.987733 210.709333,372.219733 C215.829333,364.5184 218.389333,354.3424 218.389333,341.6704 C218.389333,327.739733 215.338667,316.881067 209.258667,309.0304 C203.541333,301.627733 195.904,297.915733 186.389333,297.915733 M186.474667,275.3024 C206.613333,275.3024 222.037333,281.681067 232.768,294.481067 C243.072,306.705067 248.213333,322.427733 248.213333,341.6704 C248.213333,362.705067 242.133333,379.4304 229.973333,391.8464 C219.477333,402.577067 204.970667,407.931733 186.474667,407.931733 C166.357333,407.931733 150.912,401.553067 140.181333,388.7744 C129.877333,376.5504 124.714667,360.571733 124.714667,340.859733 C124.714667,320.251733 130.816,303.7184 142.997333,291.3024 C153.536,280.635733 168.042667,275.3024 186.474667,275.3024 M362.7456,375.477333 L371.172267,398.538667 C363.556267,402.229333 356.942933,404.704 351.268267,406.005333 C345.5936,407.285333 338.596267,407.925333 330.2976,407.925333 C317.7536,407.925333 307.3856,406.133333 299.1936,402.528 C287.716267,397.450667 279.076267,389.472 273.252267,378.570667 C268.004267,368.8 265.380267,356.853333 265.380267,342.752 C265.380267,318.965333 272.6336,300.917333 287.1616,288.693333 C297.700267,279.776 311.6096,275.317333 328.846933,275.317333 C336.206933,275.317333 342.884267,275.978667 348.9216,277.322667 C354.9376,278.688 361.7856,281.077333 369.422933,284.512 L359.758933,306.229333 C349.582933,300.682667 339.812267,297.909333 330.468267,297.909333 C319.204267,297.909333 310.5856,301.770667 304.612267,309.472 C298.340267,317.557333 295.204267,328.224 295.204267,341.493333 C295.204267,355.232 298.4896,365.984 305.060267,373.728 C311.630933,381.472 320.6976,385.333333 332.2816,385.333333 C337.508267,385.333333 342.350933,384.650667 346.7456,383.221333 C351.140267,381.813333 356.4736,379.232 362.7456,375.477333 M248.221867,7.10542736e-15 L13.5552,7.10542736e-15 L13.5552,234.666667 L56.2218667,234.666667 L56.2218667,192 L56.2218667,169.6 L56.2218667,42.6666667 L230.5152,42.6666667 L312.221867,124.373333 L312.221867,169.6 L312.221867,192 L312.221867,234.666667 L354.888533,234.666667 L354.888533,106.666667 L248.221867,7.10542736e-15 L248.221867,7.10542736e-15 Z" id="DOC"> </path> </g> </g> </g></svg>
            </div>
            ${renderDocumentName()}
          ` : html`
            <svg width="100px" height="100px" viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="var(--base-color)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M719.8 651.8m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0Z" fill="var(--base-color)"></path><path d="M512.1 64H172v896h680V385.6L512.1 64z m278.8 324.3h-280v-265l280 265zM808 916H216V108h278.6l0.2 0.2v296.2h312.9l0.2 0.2V916z" fill="var(--bg-secondary-color)"></path><path d="M280.5 530h325.9v16H280.5z" fill="var(--bg-secondary-color)"></path><path d="M639.5 530h90.2v16h-90.2z" fill="var(--base-color)"></path><path d="M403.5 641.8h277v16h-277z" fill="var(--bg-secondary-color)"></path><path d="M280.6 641.8h91.2v16h-91.2z" fill="var(--base-color)"></path><path d="M279.9 753.7h326.5v16H279.9z" fill="var(--bg-secondary-color)"></path><path d="M655.8 753.7h73.9v16h-73.9z" fill="var(--base-color)"></path></g></svg>
          `}
        </div>
        <div class="caption-container">
           <my-input
                  .value="${this.inputValue}"
                  .borderColor="${this.inputBorderColor || 'gray'}"
                  .borderWidth="${this.inputBorderWidth || '1px'}"
                  .borderRadius="${this.inputBorderRadius || "10px"}"
                  .backgroundColor="${this.inputBgColor || '#ffffff'}"
                  .fontSize="${this.inputFontSize || '14px'}"
                  .padding="10px"
                  .placeholder="${this.inputPlaceholder || 'Type your message'}"
                  .color=${this.inputFontColor}
                  .placeholderColor=${this.inputPlaceholderColor || '#000'}
                  .isSearchSvg=${false}
                  .disabled=${this.showCloseIcon}
                  @input="${this.handleInputChange}"
                ></my-input>
                ${this.conversationDetails?.isGroup ? html`<mention-user-list
                  .users=${this.conversationDetails?.members || []}
                  .isVisible=${this.showMentionList}
                  .searchQuery=${this.mentionSearchQuery}
                  .onSelectUser=${(user) => this.handleUserSelect(user)}
                  .userMetaData=${this.userMetaData}
                  .fromAttachment=${true}
                ></mention-user-list>` : null}
        </div>
       <div class="thumbnail-strip">
          <div class="thumbnails">
            ${this.content.map((item, index) => html`
              <div 
                class="thumbnail ${index === this.selectedIndex ? 'selected' : ''}"
                @click="${() => this.handleThumbnailClick(index)}"
              >
            <svg width="50px" height="50px" viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M719.8 651.8m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0Z" fill="#000000"></path><path d="M512.1 64H172v896h680V385.6L512.1 64z m278.8 324.3h-280v-265l280 265zM808 916H216V108h278.6l0.2 0.2v296.2h312.9l0.2 0.2V916z" fill="var(--bg-secondary-color)"></path><path d="M280.5 530h325.9v16H280.5z" fill="var(--bg-secondary-color)"></path><path d="M639.5 530h90.2v16h-90.2z" fill="#000000"></path><path d="M403.5 641.8h277v16h-277z" fill="var(--bg-secondary-color)"></path><path d="M280.6 641.8h91.2v16h-91.2z" fill="#000000"></path><path d="M279.9 753.7h326.5v16H279.9z" fill="var(--bg-secondary-color)"></path><path d="M655.8 753.7h73.9v16h-73.9z" fill="#000000"></path></g></svg>
              </div>
            `)}
            <button class="add-media-btn">+</button>
          </div>
          ${this.renderSendOrMicButton()}
        </div>
      </div>
    `;
  }
}

customElements.define('attachment-preview', AttachmentPreview);